import React from "react";

const SimpleDivider = () => {

    return (
        <div style={{
            lineHeight: 0,
            borderColor: 'rgba(5, 5, 5, 0.06)',
            borderStyle: 'solid',
            borderWidth: 0,
            borderTopWidth: 1,
            marginBlock: 1,
            width: '100%'
        }}></div>
    );
};
export default SimpleDivider;